import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Logo as LogoImg } from "../../routes/ImagePath";
import CurrentOrder from "../../components/Pages/CurrentOrder";
import OrderCard from "../../components/Pages/OrderCard";
import List from "../../components/Pages/List";
import Categories from "../../components/Pages/Categories";
import MyAccount from "../pages/MyAccount";
import UserAdministration from "../pages/UserAdministration";
import UserManagement from "../pages/UserManagement";
import AllUsers from "../pages/AllUsers";
import FavouriteItems from "../../components/Pages/FavouriteItems";
import ManageItems from "../../components/Pages/ManageItems";
import DashboardView from "../../components/dashboard/DashboardView";
import Loader from "../../components/common/GlobalLoader"
import useCart from "../../hooks/useCart";
import { useCreateSalesOrder } from "../../hooks/useSalesOrder";




const Dashboard = () => {
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [activeMenu, setActiveMenu] = useState("Dashboard");
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);
  const [customerName, setCustomerName] = useState("Admin User");
  const [loading, setLoading] = useState(false);
  const [showCartPopup, setShowCartPopup] = useState(false);
  const [showClearConfirm, setShowClearConfirm] = useState(false);

  const { createSalesOrder, loading: orderLoading } = useCreateSalesOrder();

const { cart, error, fetchCart, removeFromCart, clearCart } = useCart();
const cartCount = cart?.length || 0;

const [cartData, setCartData] = useState({
  _id: "6911e56ff30b42911d2015bd",
  user: "68fa8d443f1d55e0aa34c9f0",
  items: [
    {
      zohoItemId: "256873000152136501",
      name: "Gaetano - Trebbiano, 75cl",
      price: 7.29,
      quantity: 1,
      _id: "6911ed9af30b42911d2015ca",
    },
  ],
});
useEffect(() => {
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setShowDropdown(false);
    }
  };

  document.addEventListener("mousedown", handleClickOutside);
  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, []);


// 🔥 AUTO LOGOUT TIMER — ADD THIS BLOCK (DO NOT TOUCH ANYTHING ELSE)
useEffect(() => {
  let timeout;

  const resetTimer = () => {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      setLoading(true);
      localStorage.clear();
      navigate("/");
    }, 3600000); // 1 hour minutes
  };

  const events = ["mousemove", "keydown", "click", "scroll"];
  events.forEach((e) => window.addEventListener(e, resetTimer));

  resetTimer();

  return () => {
    clearTimeout(timeout);
    events.forEach((e) => window.removeEventListener(e, resetTimer));
  };
}, []);

 useEffect(() => {
    if (showCartPopup) {
      fetchCart();
    }
  }, [showCartPopup]);


  useEffect(() => {
  fetchCart();
}, [activeMenu]);
// Money formatter
const formatMoney = (value) =>
  new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: "GBP",
  }).format(value);

const getBasePrice = (cartItem) => {
  const base = cartItem?.pricingMeta?.base_rate;
  return typeof base === "number" && Number.isFinite(base) ? base : cartItem?.price || 0;
};

const getYourPrice = (cartItem) =>
  typeof cartItem?.price === "number" && Number.isFinite(cartItem.price)
    ? cartItem.price
    : 0;

  const storedUser = localStorage.getItem("user");
  const parsedUser = storedUser ? JSON.parse(storedUser) : null;
  const CustomerName = parsedUser?.CustomerName || null;

  // SUPER ADMIN BADGE (existing behaviour-only heuristic)
  const isSuperAdmin =
    parsedUser?.role === "SUPER_ADMIN" ||
    parsedUser?.isSuperAdmin === true ||
    parsedUser?.IsPrimaryContact === true;

  // PERMISSIONS FROM LOGIN RESPONSE (role.permissions)
  // If a structured permissions object exists, we treat missing permissions as FALSE.
  // For legacy users without permissions, we grant full access (default TRUE).
  const rawPermissions = parsedUser?.role?.permissions;
  const hasStructuredPermissions =
    rawPermissions && typeof rawPermissions === "object";
  const rolePermissions = hasStructuredPermissions ? rawPermissions : {};

  const getPermission = (key) => {
    // Legacy behaviour: no structured permissions → full access
    if (!hasStructuredPermissions) return true;

    return Object.prototype.hasOwnProperty.call(rolePermissions, key)
      ? !!rolePermissions[key]
      : false;
  };

  const canViewDashboard = getPermission("dashboard");
  const canViewItems = getPermission("items");
  const canViewAllOrders = getPermission("allOrders");
  const canViewOrderedItems = getPermission("viewOrderedItems");
  const canViewMyAccount = getPermission("myAccount");
  const canViewRolesAndPermissions = getPermission("rolesAndPermissions");
  const canManageItems = getPermission("manageItems");
  const canViewUserManagement = getPermission("userManagement");
  // All Users section – separate permission
  const canViewAllUsers = getPermission("allUsers");
  // Price and cart permissions
  const canViewPrices = getPermission("viewPrices");
  const canCreateSalesOrders = getPermission("createSalesOrders");

  useEffect(() => {
    const storedData = localStorage.getItem("user"); // assuming the data is stored under "user"
    if (storedData) {
      try {
        const parsedData = JSON.parse(storedData);
        if (parsedData.CustomerName) {
          setCustomerName(parsedData.CustomerName);
        }
      } catch (error) {
        console.error("Failed to parse localStorage user data:", error);
      }
    }
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
 


  return (
    <div className="min-h-screen bg-gray-50 text-gray-900">
       {/* {loading && (
  <div className="fixed inset-0 z-[999] bg-white/70 flex items-center justify-center">
    <Loader />
  </div>
)} */}
      {/* Mobile top bar */}
      <div className="flex items-center justify-between px-4 py-3 bg-white border-b md:hidden sticky top-0 z-30">
        <button
          aria-label="Open sidebar"
          onClick={() => setSidebarOpen(true)}
          className="inline-flex items-center justify-center h-10 w-10 rounded-md border border-gray-200 text-gray-600 hover:bg-gray-50"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            className="h-5 w-5"
          >
            <path
              strokeWidth="2"
              strokeLinecap="round"
              d="M3 6h18M3 12h18M3 18h18"
            />
          </svg>
        </button>
        <div className="flex items-center gap-2 select-none">
          <img src={LogoImg} alt="AyshireDrinks" className="h-7 w-auto" />
        </div>
        <div className="h-10 w-10" />
      </div>

      <div className="flex min-w-0">
        {/* Sidebar overlay (mobile) */}
        {sidebarOpen && (
          <div
            className="fixed inset-0 z-40 bg-black/30 md:hidden"
            onClick={() => setSidebarOpen(false)}
          />
        )}

        {/* Sidebar */}
        <aside
          className={`fixed z-50 inset-y-0 left-0 w-72 h-screen bg-white border-r transform transition-transform duration-200 ease-out
  ${
    sidebarOpen ? "translate-x-0" : "-translate-x-full md:translate-x-0"
  } md:translate-x-0 md:fixed md:top-0`}
        >
          <div className="hidden md:flex items-center gap-2 h-16 px-5 border-b select-none">
            <img src={LogoImg} alt="AyshireDrinks" className="h-12 w-auto" />
          </div>

          <nav className="px-3 py-4 h-[calc(100vh-4rem)] flex flex-col justify-between">
            <div>
              <button
                onClick={() => setSidebarOpen(false)}
                className="md:hidden mb-3 inline-flex items-center gap-2 px-3 py-2 rounded-md text-sm text-gray-600 hover:bg-gray-50"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  className="h-5 w-5"
                >
                  <path
                    strokeWidth="2"
                    strokeLinecap="round"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
                Close
              </button>

              <ul className="space-y-1">
                {canViewDashboard && (
                  <li>
                    <button
                      onClick={() => setActiveMenu("Dashboard")}
                      className={`relative w-full text-left flex items-center gap-3 px-4 py-3 rounded-lg ${
                        activeMenu === "Dashboard"
                          ? "bg-indigo-50 font-semibold"
                          : "hover:bg-gray-50"
                      }`}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        stroke="currentColor"
                        className="h-5 w-5"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeWidth="2"
                          strokeLinecap="round"
                          d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0h6"
                        />
                      </svg>
                      Dashboard
                      {activeMenu === "Dashboard" && (
                        <span className="absolute right-0 top-0 h-full w-1 theme-bg-primary rounded-l" />
                      )}
                    </button>
                  </li>
                )}
                {canViewItems && (
                  <li>
                    <button
                      onClick={() => setActiveMenu("Items")}
                      className={`relative w-full text-left flex items-center gap-3 px-4 py-3 rounded-lg ${
                        activeMenu === "Items"
                          ? "bg-indigo-50 font-semibold"
                          : "hover:bg-gray-50"
                      }`}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        stroke="currentColor"
                        className="h-5 w-5"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeWidth="2"
                          strokeLinecap="round"
                          d="M4 4h7v7H4V4zm9 0h7v7h-7V4zM4 13h7v7H4v-7zm9 0h7v7h-7v-7z"
                        />
                      </svg>
                      Items
                      {activeMenu === "Items" && (
                        <span className="absolute right-0 top-0 h-full w-1 theme-bg-primary rounded-l" />
                      )}
                    </button>
                  </li>
                )}
                {canViewAllOrders && (
                  <li>
                    <button
                      onClick={() => setActiveMenu("Order Card")}
                      className={`relative w-full text-left flex items-center gap-3 px-4 py-3 rounded-lg ${
                        activeMenu === "Order Card"
                          ? "bg-indigo-50 font-semibold"
                          : "hover:bg-gray-50"
                      }`}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        stroke="currentColor"
                        className="h-5 w-5"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeWidth="2"
                          strokeLinecap="round"
                          d="M3 7h18M7 3h10a2 2 0 012 2v14a2 2 0 01-2 2H7a2 2 0 01-2-2V5a2 2 0 012-2z"
                        />
                      </svg>
                      All Order
                      {activeMenu === "Order Card" && (
                        <span className="absolute right-0 top-0 h-full w-1 theme-bg-primary rounded-l" />
                      )}
                    </button>
                  </li>
                )}
                {canViewOrderedItems && (
                  <li>
                    <button
                      onClick={() => setActiveMenu("Favourite Items")}
                      className={`relative w-full text-left flex items-center gap-3 px-4 py-3 rounded-lg ${
                        activeMenu === "Favourite Items"
                          ? "bg-indigo-50 font-semibold"
                          : "hover:bg-gray-50"
                      }`}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        stroke="currentColor"
                        className="h-5 w-5"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M4.318 6.318a5.5 5.5 0 017.778 0l.904.904.904-.904a5.5 5.5 0 117.778 7.778l-8.682 8.682a1 1 0 01-1.414 0L4.318 14.096a5.5 5.5 0 010-7.778z"
                        />
                      </svg>
                      Ordered Items
                      {activeMenu === "Favourite Items" && (
                        <span className="absolute right-0 top-0 h-full w-1 theme-bg-primary rounded-l" />
                      )}
                    </button>
                  </li>
                )}
                {/* <li>
                  <button onClick={() => setActiveMenu('Current Order')} className={`relative w-full text-left flex items-center gap-3 px-4 py-3 rounded-lg ${activeMenu === 'Current Order' ? 'bg-indigo-50 font-semibold' : 'hover:bg-gray-50'}`}>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" className="h-5 w-5" viewBox="0 0 24 24">
                      <path strokeWidth="2" strokeLinecap="round" d="M4 6h16M4 12h16M4 18h7" />
                    </svg>
                    Current Order
                    {activeMenu === 'Current Order' && <span className="absolute right-0 top-0 h-full w-1 theme-bg-primary rounded-l" />}
                  </button>
                </li> */}
                {canViewMyAccount && (
                  <li>
                    <button
                      onClick={() => setActiveMenu("My Account")}
                      className={`relative w-full text-left flex items-center gap-3 px-4 py-3 rounded-lg ${
                        activeMenu === "My Account"
                          ? "bg-indigo-50 font-semibold"
                          : "hover:bg-gray-50"
                      }`}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        stroke="currentColor"
                        className="h-5 w-5"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeWidth="2"
                          strokeLinecap="round"
                          d="M12 14a5 5 0 100-10 5 5 0 000 10zm7 7a7 7 0 10-14 0"
                        />
                      </svg>
                      My Account
                      {activeMenu === "My Account" && (
                        <span className="absolute right-0 top-0 h-full w-1 theme-bg-primary rounded-l" />
                      )}
                    </button>
                  </li>
                )}
                {canViewRolesAndPermissions && (
                  <li>
                    <button
                      onClick={() => setActiveMenu("Roles & Permissions")}
                      className={`relative w-full text-left flex items-center gap-3 px-4 py-3 rounded-lg ${
                        activeMenu === "Roles & Permissions"
                          ? "bg-indigo-50 font-semibold"
                          : "hover:bg-gray-50"
                      }`}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        stroke="currentColor"
                        className="h-5 w-5"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M5.5 21a3.5 3.5 0 017 0m-3.5-4a4 4 0 110-8 4 4 0 010 8zm9.657-1.343A2.5 2.5 0 0019.5 13a2.5 2.5 0 10-2.343-3.157"
                        />
                      </svg>
                      Roles &amp; Permissions
                      {activeMenu === "Roles & Permissions" && (
                        <span className="absolute right-0 top-0 h-full w-1 theme-bg-primary rounded-l" />
                      )}
                    </button>
                  </li>
                )}
                {canViewUserManagement && (
                  <li>
                    <button
                      onClick={() => setActiveMenu("User Management")}
                      className={`relative w-full text-left flex items-center gap-3 px-4 py-3 rounded-lg ${
                        activeMenu === "User Management"
                          ? "bg-indigo-50 font-semibold"
                          : "hover:bg-gray-50"
                      }`}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        stroke="currentColor"
                        className="h-5 w-5"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M16 11V7a4 4 0 10-8 0v4M5 11h14v9H5z"
                        />
                      </svg>
                      User Management
                      {activeMenu === "User Management" && (
                        <span className="absolute right-0 top-0 h-full w-1 theme-bg-primary rounded-l" />
                      )}
                    </button>
                  </li>
                )}
                {canViewAllUsers && (
                  <li>
                    <button
                      onClick={() => setActiveMenu("All Users")}
                      className={`relative w-full text-left flex items-center gap-3 px-4 py-3 rounded-lg ${
                        activeMenu === "All Users"
                          ? "bg-indigo-50 font-semibold"
                          : "hover:bg-gray-50"
                      }`}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        stroke="currentColor"
                        className="h-5 w-5"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
                        />
                      </svg>
                      All Users
                      {activeMenu === "All Users" && (
                        <span className="absolute right-0 top-0 h-full w-1 theme-bg-primary rounded-l" />
                      )}
                    </button>
                  </li>
                )}
                {canManageItems && (
                  <li>
                    <button
                      onClick={() => setActiveMenu("Manage Items")}
                      className={`relative w-full text-left flex items-center gap-3 px-4 py-3 rounded-lg ${
                        activeMenu === "Manage Items"
                          ? "bg-indigo-50 font-semibold"
                          : "hover:bg-gray-50"
                      }`}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        stroke="currentColor"
                        className="h-5 w-5"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M4 6h16M4 12h16M4 18h16"
                        />
                      </svg>
                      Manage Items
                      {activeMenu === "Manage Items" && (
                        <span className="absolute right-0 top-0 h-full w-1 theme-bg-primary rounded-l" />
                      )}
                    </button>
                  </li>
                )}
              </ul>
            </div>

            {/* Admin User Section with Logout Dropdown */}
            <div
              className="mt-6 relative px-4 py-3 text-sm text-gray-700 border-t"
              ref={dropdownRef}
            >
              <div className="flex items-center justify-between">
                <div className="flex flex-col">
                  <span>{customerName}</span>
                  {isSuperAdmin && (
                    <span className="mt-0.5 inline-flex items-center rounded-full bg-gray-100 px-2 py-0.5 text-[11px] font-medium text-gray-700 w-max">
                      Super Admin
                    </span>
                  )}
                </div>
                <button
                  onClick={() => setShowDropdown((prev) => !prev)}
                  className="h-8 w-8 inline-flex items-center justify-center rounded-md hover:bg-gray-50"
                  title="Menu"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    className="h-4 w-4 text-gray-500"
                  >
                    <path d="M12 6.75a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm0 6a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm0 6a1.5 1.5 0 110-3 1.5 1.5 0 010 3z" />
                  </svg>
                </button>
              </div>

              {showDropdown && (
                <div className="absolute inset-x-4 sm:inset-x-auto sm:right-4 sm:left-auto bottom-[60px] z-10 bg-white border rounded shadow-lg w-auto sm:w-32">
                  <button
                    onClick={() => {
  setLoading(true);
  setShowDropdown(false);

 
  setTimeout(() => {
    localStorage.clear();
    setLoading(false);
    navigate("/");
  }, 2000); 
}}

                    className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100"
                  >
                    Logout
                  </button>
                </div>
              )}
            </div>
          </nav>
        </aside>

        {/* Main content */}
       <main className="flex-1 w-full min-w-0 md:ml-72">
  <div className="w-full max-w-full px-3 sm:px-4 md:px-6 lg:px-8 py-4 sm:py-6 md:py-8">
    <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between sm:gap-4">
      <h1 className="text-xl sm:text-2xl md:text-3xl ml-0 sm:ml-2 font-semibold theme-text-primary min-w-0 break-words pr-1 sm:pr-2 flex-1">
        {activeMenu === "Dashboard"
          ? `Welcome, ${customerName}!`
          : activeMenu}
      </h1>
       {/* ✅ View Cart button */}
  {(activeMenu === "Items" || activeMenu === "Order Card" || activeMenu === "Favourite Items" || activeMenu === "Dashboard") && (
    canCreateSalesOrders ? (
      <button
        onClick={() => setShowCartPopup(true)}
        className="shrink-0 px-4 py-2.5 text-sm font-medium bg-[#33080f] text-white rounded-lg hover:bg-[#490c15] transition-all w-full sm:w-auto text-center"
      >
        View Cart ({cartCount})
      </button>
    ) : (
      <div className="shrink-0 px-4 py-2.5 text-sm font-medium text-gray-600 bg-gray-100 rounded-lg border border-gray-300 w-full sm:w-auto text-center">
        Contact support to purchase items
      </div>
    )
  )}
    </div>

    {/* Conditional content rendering */}
    {activeMenu === "Dashboard" && (
      <div className="mt-6">
        <DashboardView />
      </div>
    )}

    {activeMenu === "Items" && (
      <div className="mt-6">
        <Categories />
      </div>
    )}
    {activeMenu === "Current Order" && (
      <div className="mt-6">
        <CurrentOrder />
      </div>
    )}
    {activeMenu === "Order Card" && (
      <div className="mt-6">
        <OrderCard />
      </div>
    )}
    {activeMenu === "Lists" && (
      <div className="mt-6">
        <List />
      </div>
    )}
    {activeMenu === "My Account" && (
      <div className="mt-6">
        <MyAccount />
      </div>
    )}
    {activeMenu === "Roles & Permissions" && (
      <div className="mt-6">
        <UserAdministration />
      </div>
    )}
    {activeMenu === "User Management" && (
      <div className="mt-6">
        <UserManagement />
      </div>
    )}
    {activeMenu === "All Users" && (
      <div className="mt-6">
        <AllUsers />
      </div>
    )}
    {activeMenu === "Favourite Items" && (
      <div className="mt-6">
        <FavouriteItems />
      </div>
    )}
    {activeMenu === "Manage Items" && (
      <div className="mt-6">
        <ManageItems />
      </div>
    )}
  </div>
</main>

      </div>
      {/* Cart Popup */}
      {showCartPopup && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
    <div className="bg-white rounded-lg w-full max-w-lg p-4 sm:p-6 shadow-lg max-h-[90vh] overflow-y-auto">

      <h2 className="text-lg sm:text-xl font-semibold mb-4">My Cart</h2>

      <div className="mb-3 text-gray-700 text-sm sm:text-base">
        <div><strong>Customer Name:</strong> {customerName}</div>
        <div><strong>Date:</strong> {new Date().toLocaleDateString()}</div>
      </div>

      {loading && <p className="text-center py-4">Loading cart...</p>}
      {error && <p className="text-center text-red-500">{error}</p>}

      {!loading && !error && (
        <>
          {cart?.length > 0 ? (
            <div className="overflow-x-auto">
              <table className="w-full text-xs sm:text-sm border-collapse mb-4">
                <thead>
                  <tr className="border-b border-gray-200 text-[11px] sm:text-xs text-gray-500 uppercase tracking-wide">
                    <th className="text-left py-2 pr-2 font-semibold normal-case">Item</th>
                    <th className="text-center py-2 px-2 font-semibold whitespace-nowrap" style={{ width: 56 }}>
                      Qty
                    </th>
                    {canViewPrices && (
                      <>
                        <th
                          className="hidden sm:table-cell text-right py-2 px-2 font-semibold whitespace-nowrap normal-case"
                          style={{ width: 110 }}
                          title="Standard item price"
                        >
                          Base
                        </th>
                        <th
                          className="text-right py-2 px-2 font-semibold whitespace-nowrap normal-case"
                          style={{ width: 120 }}
                          title="Your customer price (price list)"
                        >
                          Your price
                        </th>
                        <th
                          className="text-right py-2 pl-2 font-semibold whitespace-nowrap normal-case"
                          style={{ width: 120 }}
                        >
                          Amount
                        </th>
                      </>
                    )}
                    <th className="text-right py-2 pl-2 font-semibold normal-case" style={{ width: 72 }}>
                      Remove
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {cart.map((item) => (
                    <tr
                      key={item._id || item.zohoItemId}
                      className="border-b border-gray-100 hover:bg-gray-50/50"
                    >
                      <td className="py-3 pr-2 text-gray-900 leading-snug">{item.name}</td>
                      <td className="text-center py-3 px-2 tabular-nums text-gray-700">
                        {item.quantity}
                      </td>
                      {canViewPrices && (
                        <>
                          <td className="hidden sm:table-cell text-right py-3 px-2 tabular-nums text-gray-600">
                            {formatMoney(getBasePrice(item))}
                          </td>
                          <td className="text-right py-3 px-2 tabular-nums font-semibold text-gray-900">
                            {formatMoney(getYourPrice(item))}
                          </td>
                          <td className="text-right py-3 pl-2 tabular-nums font-semibold text-gray-900">
                            {formatMoney(getYourPrice(item) * item.quantity)}
                          </td>
                        </>
                      )}
                      {/* ❌ REMOVE ICON */}
                      <td className="text-right py-3 pl-2">
                        <button
                          onClick={() => removeFromCart(item.zohoItemId)}
                          className="inline-flex h-9 w-9 items-center justify-center rounded-md text-red-600 hover:bg-red-50 hover:text-red-700"
                          title="Remove item"
                        >
                          <span className="text-lg font-bold leading-none">×</span>
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {canViewPrices && (
                <div className="text-right font-semibold mb-4">
                  Total:{" "}
                  {formatMoney(
                    cart.reduce(
                      (sum, item) => sum + getYourPrice(item) * item.quantity,
                      0
                    )
                  )}
                </div>
              )}
            </div>
          ) : (
            <p className="text-center text-gray-500 py-4">
              Your cart is empty.
            </p>
          )}
        </>
      )}

      {/* BUTTONS */}
      <div className="flex flex-col sm:flex-row justify-end gap-3 mt-4">

        {/* ❌ CLEAR CART BUTTON */}
        {cart?.length > 0 && (
          <button
  onClick={() => setShowClearConfirm(true)}
  className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700 w-full sm:w-auto"
>
  Clear Cart
</button>

        )}

        <button
          onClick={() => setShowCartPopup(false)}
          className="px-4 py-2 border rounded hover:bg-gray-100 w-full sm:w-auto"
        >
          Close
        </button>

        {canCreateSalesOrders ? (
          <button
            onClick={async () => {
              if (!cart || cart.length === 0) return;

              // Convert cart → items + quantities
              const items = cart.map(item => ({
                id: item.zohoItemId,
                name: item.name,
              }));

              const quantities = cart.map(item => item.quantity);

              // Call API
              const response = await createSalesOrder(items, quantities);

              if (response) {
                clearCart();
                setShowCartPopup(false);
                setActiveMenu("Order Card");
              }
            }}
            className="bg-[#33080f] text-white px-4 py-2 rounded hover:bg-[#490c15] w-full sm:w-auto"
          >
            {orderLoading ? "Processing..." : "Confirm Order"}
          </button>
        ) : (
          <div className="px-4 py-2 text-sm text-gray-600 bg-gray-100 rounded border border-gray-300 w-full sm:w-auto text-center">
            Contact support to purchase items
          </div>
        )}

      </div>

    </div>
  </div>
)}
{showClearConfirm && (
  <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[999] p-4">
    <div className="bg-white rounded-lg p-6 w-full max-w-sm shadow-lg">
      <h2 className="text-lg font-semibold mb-4 text-center">Clear Cart?</h2>
      <p className="text-gray-600 text-center mb-6">Are you sure you want to remove all items from your cart?</p>

      <div className="flex justify-center gap-3">
        <button
          onClick={() => {
            clearCart();
            setShowClearConfirm(false);
          }}
          className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
        >
          Yes, Clear
        </button>

        <button
          onClick={() => setShowClearConfirm(false)}
          className="px-4 py-2 border rounded hover:bg-gray-100"
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
)}


    </div>
  );
};

export default Dashboard;
